var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('RouterView',{attrs:{"WebSiteConfig":_vm.WebSiteConfig,"WebSite":_vm.WebSite,"UserTur":_vm.UserTur},on:{"UserTur":function($event){_vm.UserTur = $event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }